module.exports = __webpack_public_path__ + "static/media/scholarship-awards.b5a4f378.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/scholarship-awards.pdf
// module id = 95
// module chunks = 0